module.exports = __webpack_public_path__ + "img/zs_20@2x.be0d6562.png";